import React, { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { authLogin, fetchMe, setAuthToken } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = authed

  useEffect(() => {
    const t = localStorage.getItem("nl_token");
    if (!t) { setUser(false); return; }
    fetchMe().then(setUser).catch(() => { setAuthToken(null); setUser(false); });
  }, []);

  const signIn = async (email, password) => {
    const { token, user: u } = await authLogin(email, password);
    setAuthToken(token);
    setUser(u);
    return u;
  };
  const signOut = () => { setAuthToken(null); setUser(false); };

  return <AuthCtx.Provider value={{ user, signIn, signOut }}>{children}</AuthCtx.Provider>;
}

export function RequireAuth({ children, adminOnly = false }) {
  const { user } = useAuth();
  if (user === null) return <div className="font-ui p-16 text-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/admin" replace />;
  return children;
}
